import { customerioTracker } from 'lib'
import { analyticsTracker } from 'utils'

export function trackAddedItems({ jobId, items }) {
  const mixpanelTrackObj = {
    providers: [],
    types: [],
    ids: [],
  }

  items.forEach(item => {
    mixpanelTrackObj.providers.push(item?.provider)
    mixpanelTrackObj.types.push(item?.type)
    mixpanelTrackObj.ids.push(String(item?.id))
  })

  const finalProviders = Array.from(new Set(mixpanelTrackObj.providers)).filter(Boolean) as string[]
  const finalTypes = Array.from(new Set(mixpanelTrackObj.types)).filter(Boolean) as string[]
  const finalIds = Array.from(new Set(mixpanelTrackObj.ids))

  const { ADD_TO } = analyticsTracker.eventNames
  const { INSIGHT_SAVED } = customerioTracker.eventNames

  customerioTracker.track(INSIGHT_SAVED, {
    content_added: finalTypes,
    job_id: jobId,
  })

  analyticsTracker.eventTrack(ADD_TO, {
    'Content added': finalTypes,
    'Content id': finalIds,
    'Content provider': finalProviders,
    'Job ID': jobId,
  })
}
